import styled from 'styled-components';

export const GuidesLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const GuidesSummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const GuidesSummaryCard = styled.div`
  padding: 18px;
  border-radius: 20px;
  border: 1px solid rgba(24, 90, 66, 0.08);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.96) 0%,
    rgba(248, 252, 250, 0.96) 100%
  );
  box-shadow: 0 16px 40px rgba(18, 62, 51, 0.06);

  .label {
    color: #6f857b;
    font-size: 0.82rem;
  }

  .value {
    margin-top: 6px;
    font-size: 1.5rem;
    font-weight: 700;
    color: #143d30;
  }

  .value.success {
    color: #15803d;
  }

  .value.warning {
    color: #b7791f;
  }

  .value.currency {
    font-size: 1.2rem;
  }
`;

interface IColorStatus {
  colorText: string | undefined;
}

export const ColorStatusText = styled.div<IColorStatus>`
  color: ${(props) => props.colorText ?? '#000'};
  font-weight: 700;
  font-size: 11px;
`;

export const CurrencyText = styled.div`
  font-weight: 500;
`;
